module.exports = __webpack_public_path__ + "img/dyp16.6ee2d2ae.jpg";